import { z } from "zod/v4";
import { PatientsIdSchema } from "../zodSchemas.js";
export const TpePaymentsIdSchema = z
    .string()
    .uuid()
    .transform((value) => value);
export const TpePaymentStatusSchema = z.enum([
    "pending",
    "approved",
    "manually_recorded",
    "not_completed",
    "unknown",
]);
export const TpeTerminalPaymentStatusSchema = z.enum([
    "pending",
    "approved",
    "not_completed",
    "unknown",
]);
export const TpePaymentMethodSchema = z.enum([
    "insertion",
    "sansContact",
    "amex",
]);
export const tpePaymentMethodLabels = {
    insertion: "Avec insertion",
    sansContact: "Sans contact",
    amex: "AMEX",
};
// CAISSE-AP field "ci" (card read mode) returned by the TPE.
// Values observed on a real V200c: "1" = chip inserted, "2" = contactless.
// Unknown values fall back to manual selection in the UI.
const cardReadModeToPaymentMethod = {
    "1": "insertion",
    "2": "sansContact",
};
export const paymentMethodFromCardReadMode = (cardReadMode) => {
    if (!cardReadMode) {
        return null;
    }
    return cardReadModeToPaymentMethod[cardReadMode.trim().toUpperCase()] ?? null;
};
export const TpeAmountCentsSchema = z
    .number()
    .int()
    .positive()
    .max(999999999999);
export const TpeCurrencySchema = z.literal("EUR");
export const TpeClientRequestIdSchema = z.string().uuid();
export const tpePaymentCreateIntentInputSchema = z.object({
    patientId: PatientsIdSchema,
    amountCents: TpeAmountCentsSchema,
    currency: TpeCurrencySchema,
    clientRequestId: TpeClientRequestIdSchema,
});
export const tpePaymentManualCreateInputSchema = z.object({
    patientId: PatientsIdSchema,
    amountCents: TpeAmountCentsSchema,
    currency: TpeCurrencySchema,
    paymentMethod: TpePaymentMethodSchema,
    paymentDate: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
});
export const tpePaymentResultSchema = z.object({
    status: TpeTerminalPaymentStatusSchema,
    // CAISSE-AP fixed-width fields (AF is 29 chars with inner space padding,
    // AC holds the authorization number), so allow more than the nominal code.
    authorization: z.string().max(64).nullable().optional(),
    resultCode: z.string().max(8).nullable().optional(),
    resultDetail: z.string().max(64).nullable().optional(),
    paymentMode: z.string().max(16).nullable().optional(),
    cardReadMode: z.string().max(16).nullable().optional(),
});
export const commitTpePaymentResultSchema = z.object({
    paymentId: TpePaymentsIdSchema,
    clientRequestId: TpeClientRequestIdSchema,
    amountCents: TpeAmountCentsSchema,
    currency: TpeCurrencySchema,
    result: tpePaymentResultSchema,
});
//# sourceMappingURL=TpePaymentSchemas.js.map